import React from 'react';
import {Price, PrevPrice, DiscountedPrice} from './styles';

const PackagePrice = ({price, discountedPrice, planType, currency}) => {
  const currentCurrency = currency === 'USD' ? 'دولار' : currency === 'KWD' ? 'دينار كويتي' : 'جنيه مصري'
  return (
    <Price>
      <PrevPrice>{price}$</PrevPrice>
      <DiscountedPrice>{discountedPrice} </DiscountedPrice>
      <p>
        <span>{currentCurrency}</span> / {planType === 'MONTHLY' ? 'شهريا' : 'سنويا'}
      </p>
    </Price>
)}

export default PackagePrice;
